



// // FeeMaster.jsx
// import React, { useState, useEffect } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   createFee,
//   fetchAllFees,
//   updateFee,
// } from "../redux/slices/feeAssignSlice";

// import { fetchAllServiceTypes } from "../redux/slices/service_type";
// import { fetchAllServices } from "../redux/slices/serviceSliceloan";

// import "../assets/FeeMaster.css";

// const FeeMaster = () => {
//   const dispatch = useDispatch();
//   const { allFees, loading } = useSelector((state) => state.feeAssign);
//   const { allServiceTypes } = useSelector((state) => state.serviceType);
//   const { allServices } = useSelector((state) => state.serviceloan);

//   // Modal & form state
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [feeName, setFeeName] = useState("");
//   const [feeDescription, setFeeDescription] = useState("");
//   const [applicableOn, setApplicableOn] = useState("Disbursal");
//   const [serviceType, setServiceType] = useState("");
//   const [serviceloanType, setServiceloanType] = useState("");

//   // Local edited fees
//   const [editedFees, setEditedFees] = useState({});

//   // Pagination
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5;
//   const totalPages = Math.ceil(allFees.length / itemsPerPage);

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentFees = allFees.slice(indexOfFirstItem, indexOfLastItem);

//   useEffect(() => {
//     dispatch(fetchAllServiceTypes());
//     dispatch(fetchAllFees());
//   }, [dispatch]);

//   // // --- Add Fee ---
//   // const handleAddFee = async () => {
//   //   const selectedServiceType = allServiceTypes.find(
//   //     (stype) => String(stype.id) === String(serviceType)
//   //   );
//   //   const selectedService = allServices.find(
//   //     (srv) => String(srv.id) === String(serviceloanType)
//   //   );

//   //   const payload = {
//   //     name: feeName,
//   //     description: feeDescription || "No description",
//   //     applicableOn,
//   //     serviceType: serviceType || "",
//   //     service: serviceloanType || "",
//   //     superadminId: localStorage.getItem("adminuserId") || 14,
//   //   };

//   //   await dispatch(createFee(payload));
//   //   await dispatch(fetchAllFees());

//   //   // Reset modal
//   //   setFeeName("");
//   //   setFeeDescription("");
//   //   setApplicableOn("Disbursal");
//   //   setServiceType("");
//   //   setServiceloanType("");
//   //   setIsModalOpen(false);
//   // };




//   const handleAddFee = async () => {
//   const selectedServiceType = allServiceTypes.find(
//     (stype) => String(stype.id) === String(serviceType)
//   );

//   const selectedService = allServices.find(
//     (srv) => String(srv.id) === String(serviceloanType)
//   );

//   const payload = {
//     name: feeName,
//     description: feeDescription || "No description",
//     applicableOn,
//     serviceType: selectedServiceType ? String(selectedServiceType.id) : "",
//     service: selectedService ? String(selectedService.id) : "",
//     superadminId: localStorage.getItem("adminuserId") || 14,
//   };

//   await dispatch(createFee(payload));
//   await dispatch(fetchAllFees());

//   // Reset modal
//   setFeeName("");
//   setFeeDescription("");
//   setApplicableOn("Disbursal");
//   setServiceType("");
//   setServiceloanType("");
//   setIsModalOpen(false);
// };

//   // --- Handle local edit ---
//   const handleLocalEdit = (id, field, value) => {
//     setEditedFees((prev) => ({
//       ...prev,
//       [id]: {
//         ...prev[id],
//         [field]: value,
//       },
//     }));
//   };

//   // --- Save row ---
//   const handleSaveRow = async (id) => {
//     if (!editedFees[id]) return;

//     const selectedServiceType = allServiceTypes.find(
//       (stype) => String(stype.id) === String(serviceType)
//     );
//     const selectedService = allServices.find(
//       (srv) => String(srv.id) === String(serviceloanType)
//     );

//     const payload = {
//       ...editedFees[id],
//       serviceType: selectedServiceType?.id?.toString() || "",
//       service: selectedService?.id?.toString() || "",
//     };

//     await dispatch(updateFee({ id, data: payload }));
//     await dispatch(fetchAllFees());

//     setEditedFees((prev) => {
//       const updated = { ...prev };
//       delete updated[id];
//       return updated;
//     });
//   };

//   // --- ServiceType change ---
//   const handleServiceTypeChange = (e) => {
//     const selectedTypeId = e.target.value;
//     setServiceType(selectedTypeId);
//     setServiceloanType(""); // reset service dropdown

//     if (selectedTypeId) {
//       dispatch(
//         fetchAllServices({
//           superadminId: localStorage.getItem("adminuserId") || 14,
//           serviceTypeId: selectedTypeId,
//         })
//       );
//     }
//   };

//   // --- Search ---
//   const handleSearch = () => {
//     dispatch(
//       fetchAllFees({
//         applicableOn,
//         serviceType: serviceType?.toString(),
//         service: serviceloanType?.toString(),
//       })
//     );
//     setCurrentPage(1); // reset page
//   };

//   // --- Pagination handlers ---
//   const handleNextPage = () => {
//     if (currentPage < totalPages) setCurrentPage(currentPage + 1);
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) setCurrentPage(currentPage - 1);
//   };

//   return (
//     <div className="FeeMaster-container">
//       {/* Modal */}
//       {isModalOpen && (
//         <div className="FeeMaster-modalOverlay">
//           <div className="FeeMaster-modal">
//             <h3>Add New Fee</h3>
//             <div className="FeeMaster-formGroup">
//               <label>Fee Name</label>
//               <input
//                 type="text"
//                 value={feeName}
//                 onChange={(e) => setFeeName(e.target.value)}
//               />
//             </div>
//             {/* <div className="FeeMaster-formGroup">
//               <label>Fee Description</label>
//               <textarea
//                 value={feeDescription}
//                 onChange={(e) => setFeeDescription(e.target.value)}
//               />
//             </div> */}
//             <div className="FeeMaster-formGroup">
//               <label>Applicable On</label>
//               <select
//                 value={applicableOn}
//                 onChange={(e) => setApplicableOn(e.target.value)}
//               >
//                 <option>Disbursal</option>
//                 <option>Installment</option>
//                 <option>Late Payment</option>
//               </select>
//             </div>



//               <div className="FeeMaster-formGroup">
//               <label>Service Type</label>
//               <select
//                 value={serviceType}
//                 onChange={handleServiceTypeChange}
//               >
//                 <option value="">-- Select Service Type --</option>
//                 {allServiceTypes.map((stype) => (
//                   <option key={stype.id} value={stype.id}>
//                     {stype.name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="FeeMaster-formGroup">
//               <label>Service</label>
//               <select
//                 value={serviceloanType}
//                 onChange={(e) => setServiceloanType(e.target.value)}
//               >
//                 <option value="">-- Select Service --</option>
//                 {allServices.map((srv) => (
//                   <option key={srv.id} value={srv.id}>
//                     {srv.name || srv.serviceName}
//                   </option>
//                 ))}
//               </select>
//             </div>






//             <div className="FeeMaster-modalActions">
//               <button onClick={() => setIsModalOpen(false)}>Cancel</button>
//               <button onClick={handleAddFee}>Save</button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Header */}
//       <div className="FeeMaster-card">
//         <div className="FeeMaster-header">
//           <div>
//             <h2 className="FeeMaster-title">Service Fee Assignment</h2>
//             <p className="FeeMaster-subtitle">Assign fee to services.</p>
//           </div>
//           <button
//             className="FeeMaster-addBtn"
//             onClick={() => setIsModalOpen(true)}
//           >
//             Add New Fee
//           </button>
//         </div>

//         <form className="FeeMaster-form">
//           <div className="FeeMaster-formGrid">
//             <div className="FeeMaster-formGroup">
//               <label>Choose Service Type</label>
//               {/* <select value={serviceType} onChange={handleServiceTypeChange}>
//                 <option value="">-- Select Service Type --</option>
//                 {allServiceTypes.map((stype) => (
//                   <option key={stype.id} value={stype.id}>
//                     {stype.name}
//                   </option>
//                 ))}
//               </select> */}
//               <select value={serviceType} onChange={handleServiceTypeChange}>
//                                 <option value="">-- Select Service Type --</option>

//   {allServiceTypes.map((stype) => (
    
//     <option key={stype.id} value={stype.id}>
//       {stype.name}
//     </option>
//   ))}
// </select>

//             </div>

//             <div className="FeeMaster-formGroup">
//               <label>Choose Service</label>

//               <select
//   value={serviceloanType}
//   onChange={(e) => setServiceloanType(e.target.value)}
// >
//   {allServices.map((srv) => (
//     <option key={srv.id} value={srv.id}>
//       {srv.name || srv.serviceName}
//     </option>
//   ))}
// </select>

//               {/* <select
//                 value={serviceloanType}
//                 onChange={(e) => setServiceloanType(e.target.value)}
//               >
//                 <option value="">-- Select Service --</option>
//                 {allServices && allServices.length > 0 ? (
//                   allServices.map((srv) => (
//                     <option key={srv.id} value={srv.id}>
//                       {srv.name || srv.serviceName}
//                     </option>
//                   ))
//                 ) : (
//                   <option disabled>No services found</option>
//                 )}
//               </select> */}

//             </div>
//           </div>

//           <div className="FeeMaster-formGroupWide">
//             <label>Applicable On</label>
//             <select
//               value={applicableOn}
//               onChange={(e) => setApplicableOn(e.target.value)}
//             >
//               <option>Disbursal</option>
//               <option>Installment</option>
//               <option>Late Payment</option>
//             </select>
//           </div>

//           <button
//             type="button"
//             className="FeeMaster-searchBtn"
//             onClick={handleSearch}
//           >
//             SEARCH
//           </button>
//         </form>
//       </div>

//       {/* Fee Table */}
//       <div className="FeeMaster-card">
//         <h2 className="FeeMaster-title">Service List</h2>
//         <p className="FeeMaster-subtitle">Fetched from backend API.</p>
//         {loading ? (
//           <p>Loading...</p>
//         ) : (
//           <>
//             <div className="FeeMaster-tableContainer">
//               <table className="FeeMaster-table">
//                 <thead>
//                   <tr>
//                     <th>SN</th>
//                     <th>FEE NAME</th>
//                     <th>FEE DETAILS</th>
//                     <th>GRACE DETAILS</th>
//                     <th>ACTIVE</th>
//                     <th>GST</th>
//                     <th>ACTION</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {currentFees.map((fee, index) => {
//                     const edited = editedFees[fee.id] || {};
//                     return (
//                       <tr key={fee.id}>
//                         <td>{indexOfFirstItem + index + 1}</td>
//                         <td>
//                           <strong>{fee.name}</strong>
//                           <p className="FeeMaster-subText">{fee.description}</p>
//                         </td>

//                         {/* Fee Details */}
//                         <td>
//                           <div className="FeeMaster-inputBox">
//                             <div className="FeeMaster-radioGroup">
//                               <label>
//                                 <input
//                                   type="radio"
//                                   name={`feeType${index}`}
//                                   checked={
//                                     (edited.type || fee.type) === "Percentage"
//                                   }
//                                   onChange={() =>
//                                     handleLocalEdit(fee.id, "type", "Percentage")
//                                   }
//                                 />{" "}
//                                 Percentage
//                               </label>
//                               <label>
//                                 <input
//                                   type="radio"
//                                   name={`feeType${index}`}
//                                   checked={(edited.type || fee.type) === "Fixed"}
//                                   onChange={() =>
//                                     handleLocalEdit(fee.id, "type", "Fixed")
//                                   }
//                                 />{" "}
//                                 Fixed
//                               </label>
//                             </div>
//                             <input
//                               type="number"
//                               placeholder="Fee Value"
//                               className="FeeMaster-inputDark"
//                               value={edited.value ?? fee.value ?? ""}
//                               onChange={(e) =>
//                                 handleLocalEdit(fee.id, "value", e.target.value)
//                               }
//                             />
//                           </div>
//                         </td>

//                         {/* Grace Details */}
//                         <td>
//                           <div className="FeeMaster-inputBox">
//                             <div className="FeeMaster-radioGroup">
//                               {["Days", "Months"].map((opt) => (
//                                 <label key={opt}>
//                                   <input
//                                     type="radio"
//                                     name={`graceType${index}`}
//                                     checked={(edited.graceType || fee.graceType) === opt}
//                                     onChange={() =>
//                                       handleLocalEdit(fee.id, "graceType", opt)
//                                     }
//                                   />{" "}
//                                   {opt}
//                                 </label>
//                               ))}
//                             </div>
//                             <input
//                               type="number"
//                               placeholder="Grace Value"
//                               className="FeeMaster-inputDark"
//                               value={edited.graceValue ?? fee.graceValue ?? ""}
//                               onChange={(e) =>
//                                 handleLocalEdit(fee.id, "graceValue", e.target.value)
//                               }
//                             />
//                           </div>
//                         </td>

//                         {/* Active Toggle */}
//                         <td className="FeeMaster-toggleCell">
//                           <label className="FeeMaster-toggle">
//                             <input
//                               type="checkbox"
//                               checked={edited.active ?? fee.active ?? false}
//                               onChange={(e) =>
//                                 handleLocalEdit(fee.id, "active", e.target.checked)
//                               }
//                             />
//                             <span className="FeeMaster-slider"></span>
//                           </label>
//                         </td>

//                         {/* GST Toggle */}
//                         <td className="FeeMaster-toggleCell">
//                           <label className="FeeMaster-toggle">
//                             <input
//                               type="checkbox"
//                               checked={edited.gstIncluded ?? fee.gstIncluded ?? false}
//                               onChange={(e) =>
//                                 handleLocalEdit(fee.id, "gstIncluded", e.target.checked)
//                               }
//                             />
//                             <span className="FeeMaster-slider gst"></span>
//                           </label>
//                         </td>

//                         {/* Action */}
//                         <td>
//                           <button
//                             type="button"
//                             className="FeeMaster-saveButton"
//                             onClick={() => handleSaveRow(fee.id)}
//                           >
//                             Save
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>

//             {/* Pagination */}
//             <div className="FeeMaster-pagination">
//               <button onClick={handlePrevPage} disabled={currentPage === 1}>
//                 Previous
//               </button>
//               <span>
//                 Page {currentPage} of {totalPages}
//               </span>
//               <button
//                 onClick={handleNextPage}
//                 disabled={currentPage === totalPages}
//               >
//                 Next
//               </button>
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default FeeMaster;

// FeeMaster.jsx
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { FaSave, FaTrash } from "react-icons/fa";
import {
  createFee,
  fetchAllFees,
  updateFee,
} from "../redux/slices/feeAssignSlice";

import { fetchAllServiceTypes } from "../redux/slices/service_type";
import { fetchAllServices } from "../redux/slices/serviceSliceloan";

import "../assets/FeeMaster.css";
import axios from "axios";

const FeeMaster = () => {
  const dispatch = useDispatch();
  const { allFees, loading,  } = useSelector((state) => state.feeAssign);
  const { allServiceTypes } = useSelector((state) => state.serviceType);
  const { allServices } = useSelector((state) => state.serviceloan);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [feeName, setFeeName] = useState("");
  const [feeDescription, setFeeDescription] = useState("");
  const [applicableOn, setApplicableOn] = useState("Disbursal");
  const [serviceType, setServiceType] = useState("");
  const [serviceloanType, setServiceloanType] = useState("");

  const [editedFees, setEditedFees] = useState({});

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const totalPages = Math.ceil(allFees.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentFees = allFees.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    dispatch(fetchAllServiceTypes());
    dispatch(fetchAllFees());
  }, [dispatch]);

  const handleAddFee = async () => {
    const selectedServiceType = allServiceTypes.find(
      (stype) => String(stype.id) === String(serviceType)
    );

    const selectedService = allServices.find(
      (srv) => String(srv.id) === String(serviceloanType)
    );

    console.log("service type",selectedService)
    const payload = {
      name: feeName,
      description: feeDescription || "No description",
      applicableOn,
      serviceType: selectedServiceType ? String(selectedServiceType.id) : "",
      service: selectedService ? String(selectedService.id) : "",
      superadminId: localStorage.getItem("adminuserId") || 14,
    };

    await dispatch(createFee(payload));
    await dispatch(fetchAllFees());

    setFeeName("");
    setFeeDescription("");
    setApplicableOn("Disbursal");
    setServiceType("");
    setServiceloanType("");
    setIsModalOpen(false);
  };

  const handleLocalEdit = (id, field, value) => {
    setEditedFees((prev) => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      },
    }));
  };

  const handleSaveRow = async (id) => {
    if (!editedFees[id]) return;

    const selectedServiceType = allServiceTypes.find(
      (stype) => String(stype.id) === String(serviceType)
    );
    const selectedService = allServices.find(
      (srv) => String(srv.id) === String(serviceloanType)
    );

    const payload = {
      ...editedFees[id],
      serviceType: selectedServiceType?.id?.toString() || "",
      service: selectedService?.id?.toString() || "",
    };

    await dispatch(updateFee({ id, data: payload }));
    await dispatch(fetchAllFees());

    setEditedFees((prev) => {
      const updated = { ...prev };
      delete updated[id];
      return updated;
    });
  };

  const handleServiceTypeChange = (e) => {
    const selectedTypeId = e.target.value;
    setServiceType(selectedTypeId);
    setServiceloanType("");

    if (selectedTypeId) {
      dispatch(
        fetchAllServices({
          superadminId: localStorage.getItem("adminuserId") || 14,
          serviceTypeId: selectedTypeId,
        })
      );
    }
  };

  const handleSearch = () => {
    dispatch(
      fetchAllFees({
        applicableOn,
        serviceType: serviceType?.toString(),
        service: serviceloanType?.toString(),
      })
    );
    setCurrentPage(1);
  };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this scheme?")) return;
        console.log(id)
        // setSubmitting(true);
        try {
          await axios
          .delete(`https://narrowitsolution.in/api/delete-fees-master/${id}`);
          await dispatch(fetchAllFees());
          alert("Deleted successfully");
        } catch (err) {
          console.error("Delete error:", err);
          // setError("Delete failed.");
        } finally {
          // setSubmitting(false);
        }
      };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  return (
    <div className="FeeMaster-container">
      {isModalOpen && (
        <div className="FeeMaster-modalOverlay">
          <div className="FeeMaster-modal">
            <h3>Add New Fee</h3>
            <div className="FeeMaster-formGroup">
              <label>Fee Name</label>
              <input
                type="text"
                value={feeName}
                onChange={(e) => setFeeName(e.target.value)}
              />
            </div>

            <div className="FeeMaster-formGroup">
              <label>Applicable On</label>
              <select
                value={applicableOn}
                onChange={(e) => setApplicableOn(e.target.value)}
              >
                <option>Disbursal</option>
                <option>Installment</option>
                <option>Late Payment</option>
              </select>
            </div>

            <div className="FeeMaster-formGroup">
              <label>Service Type</label>
              <select value={serviceType} onChange={handleServiceTypeChange}>
                <option value="">-- Select Service Type --</option>
                {allServiceTypes.map((stype) => (
                  <option key={stype.id} value={stype.id}>
                    {stype.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="FeeMaster-formGroup">
              <label>Service</label>
              <select
                value={serviceloanType}
                onChange={(e) => setServiceloanType(e.target.value)}
              >
                <option value="">-- Select Service --</option>
                {allServices.map((srv) => (
                  <option key={srv.id} value={srv.id}>
                    {srv.name || srv.serviceName}
                  </option>
                ))}
              </select>
            </div>

            <div className="FeeMaster-modalActions">
              <button onClick={() => setIsModalOpen(false)}>Cancel</button>
              <button onClick={handleAddFee}>Save</button>
            </div>
          </div>
        </div>
      )}

      <div className="FeeMaster-card-top">
        <div className="FeeMaster-header">
          <div>
            <h2 className="FeeMaster-title-top">Service Fee Assignment</h2>
            <p className="FeeMaster-subtitle-top">Assign fee to services.</p>
          </div>
          <button
            className="FeeMaster-addBtn"
            onClick={() => setIsModalOpen(true)}
          >
            Add New Fee
          </button>
        </div>

        <form className="FeeMaster-form">
          <div className="FeeMaster-formGrid">
            <div className="FeeMaster-formGroup">
              <label>Choose Service Type</label>
              <select value={serviceType} onChange={handleServiceTypeChange}>
                <option value="">-- Select Service Type --</option>
                {allServiceTypes.map((stype) => (
                  <option key={stype.id} value={stype.id}>
                    {stype.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="FeeMaster-formGroup">
              <label>Choose Service</label>
              <select
                value={serviceloanType}
                onChange={(e) => setServiceloanType(e.target.value)}
              >
                <option value="">-- Select Service --</option>
                {allServices.map((srv) => (
                  <option key={srv.id} value={srv.id}>
                    {srv.name || srv.serviceName}
                  </option>
                ))}
              </select>
            </div>
          

          <div className="FeeMaster-formGroupWide">
            <label>Applicable On</label>
            <select
              value={applicableOn}
              onChange={(e) => setApplicableOn(e.target.value)}
            >
              <option>Disbursal</option>
              <option>Installment</option>
              <option>Late Payment</option>
            </select>
          </div></div>

          <button
            type="button"
            className="FeeMaster-searchBtn"
            onClick={handleSearch}
          >
            SEARCH
          </button>
        </form>
      </div>

      <div className="FeeMaster-card">
        <h2 className="FeeMaster-title">Service List</h2>
        <p className="FeeMaster-subtitle">Fetched from backend API.</p>

          <p>{currentFees.length}</p>

        {loading ? (
          <p>Loading...</p>
        ) :
        
        currentFees.length > 0 ? (
          <>
            <div className="FeeMaster-tableContainer">
              <table className="FeeMaster-table">
                <thead>
                  <tr>
                    <th>SN</th>
                    <th>FEE NAME</th>
                    <th>FEE DETAILS</th>
                    <th>GRACE DETAILS</th>
                    <th>ACTIVE</th>
                    <th>GST</th>
                    <th>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {currentFees.map((fee, index) => {
                    const edited = editedFees[fee.id] || {};
                    return (
                      <tr key={fee.id}>
                        <td>{indexOfFirstItem + index + 1}</td>
                        <td>
                          <strong>{fee.name}</strong>
                          <p className="FeeMaster-subText">{fee.description}</p>
                        </td>
                        <td>
                          <div className="FeeMaster-inputBox">
                            <div className="FeeMaster-radioGroup">
                              <label>
                                <input
                                  type="radio"
                                  name={`feeType${index}`}
                                  checked={
                                    (edited.type || fee.type) === "Percentage"
                                  }
                                  onChange={() =>
                                    handleLocalEdit(fee.id, "type", "Percentage")
                                  }
                                />{" "}
                                Percentage
                              </label>
                              <label>
                                <input
                                  type="radio"
                                  name={`feeType${index}`}
                                  checked={(edited.type || fee.type) === "Fixed"}
                                  onChange={() =>
                                    handleLocalEdit(fee.id, "type", "Fixed")
                                  }
                                />{" "}
                                Fixed
                              </label>
                            </div>
                            <input
                              type="number"
                              placeholder="Fee Value"
                              className="FeeMaster-inputDark"
                              value={edited.value ?? fee.value ?? ""}
                              onChange={(e) =>
                                handleLocalEdit(fee.id, "value", e.target.value)
                              }
                            />
                          </div>
                        </td>
                        <td>
                          <div className="FeeMaster-inputBox">
                            <div className="FeeMaster-radioGroup">
                              {["Days", "Months"].map((opt) => (
                                <label key={opt}>
                                  <input
                                    type="radio"
                                    name={`graceType${index}`}
                                    checked={
                                      (edited.graceType || fee.graceType) === opt
                                    }
                                    onChange={() =>
                                      handleLocalEdit(fee.id, "graceType", opt)
                                    }
                                  />{" "}
                                  {opt}
                                </label>
                              ))}
                            </div>
                            <input
                              type="number"
                              placeholder="Grace Value"
                              className="FeeMaster-inputDark"
                              value={edited.graceValue ?? fee.graceValue ?? ""}
                              onChange={(e) =>
                                handleLocalEdit(fee.id, "graceValue", e.target.value)
                              }
                            />
                          </div>
                        </td>
                        <td className="FeeMaster-toggleCell">
                          <label className="FeeMaster-toggle">
                            <input
                              type="checkbox"
                              checked={edited.active ?? fee.active ?? false}
                              onChange={(e) =>
                                handleLocalEdit(fee.id, "active", e.target.checked)
                              }
                            />
                            <span className="FeeMaster-slider"></span>
                          </label>
                        </td>
                        <td className="FeeMaster-toggleCell">
                          <label className="FeeMaster-toggle">
                            <input
                              type="checkbox"
                              checked={edited.gstIncluded ?? fee.gstIncluded ?? false}
                              onChange={(e) =>
                                handleLocalEdit(fee.id, "gstIncluded", e.target.checked)
                              }
                            />
                            <span className="FeeMaster-slider gst"></span>
                          </label>
                        </td>
                        <td>
                         <button
                            type="button"
                            className="FeeMaster-saveButton"
                            onClick={() => handleSaveRow(fee.id)}
                            aria-label="Save fee"
                            title="Save"
                          >
                            <FaSave />
                          </button>

                          <button
                            type="button"
                            className="FeeMaster-deleteButton"
                            onClick={() => handleDelete(fee.id)}
                            aria-label="Delete fee"
                            title="Delete"
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            <div className="FeeMaster-pagination">
              <button onClick={handlePrevPage} disabled={currentPage === 1}>
                Previous
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={handleNextPage}
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </>
        ) : (
          <p>No fees found for the given criteria.</p>
        )}
      </div>
    </div>
  );
};

export default FeeMaster;


